// extracted by mini-css-extract-plugin
export default {"overlay":"Modal_overlay__lypxW","content":"Modal_content__JPpQD","closeBtn":"Modal_closeBtn__juzPZ"};